import { render, staticRenderFns } from "./crewSelectionPurchase.vue?vue&type=template&id=972b039e&scoped=true"
import script from "./crewSelectionPurchase.vue?vue&type=script&lang=js"
export * from "./crewSelectionPurchase.vue?vue&type=script&lang=js"
import style0 from "./crewSelectionPurchase.vue?vue&type=style&index=0&id=972b039e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b039e",
  null
  
)

export default component.exports